import React, { useEffect, useState } from 'react';
import { getAuth, signOut } from 'firebase/auth';
import { Link, useNavigate } from 'react-router-dom';

const Navbar = () => {
  const navigate = useNavigate();
  const [auth, setAuth] = useState(null);
  const [name, setName] = useState(null);

  useEffect(() => {
    const auth = getAuth();
    setAuth(auth);

    const user = auth.currentUser;
    if (user) {
      console.log({ user });
      setName(user.displayName);
    }
  }, [auth]);

  const handleSignOut = () => {
    signOut(auth)
      .then(() => {
        // Sign-out successful.
        navigate('/login', {
          replace: true,
        });
        console.log('signed out');
      })
      .catch((error) => {
        // An error happened.
        console.log(error);
      });
  };

  return (
    <div className="flex justify-between items-center gap-4 px-10 py-4 shadow">
      <Link to="/">
        <div className="italic text-lg">Home</div>
      </Link>

      <div>
        <Link to="/transactions-history">
          <button className=" text-black font-bold py-2 px-4 rounded text-lg">
            Transactions history
          </button>
        </Link>
        <button onClick={handleSignOut} className="underline text-lg">
          Logout
        </button>
      </div>
    </div>
  );
};

export default Navbar;
